module.exports = __webpack_public_path__ + "static/media/wrapper-button-go-next-page.64d547e8.png";